import theme from '~/styles/theme';

export const mobile = theme.current.breakpoints.down('sm');
export const mobilePWA = `${mobile} and (display-mode: standalone)`;
